import { motion } from "framer-motion";
import { CheckCircle } from "lucide-react";
import CountdownTimer from "@/components/CountdownTimer";
import CheckoutButton from "@/components/CheckoutButton";

const ease = [0.16, 1, 0.3, 1];

export default function PriceSection() {
  return (
    <section
      className="py-32 md:py-40 px-6 bg-[#0A0A0A]"
      data-testid="price-section"
      style={{ borderTop: "1px solid rgba(255,255,255,0.06)" }}
    >
      <div className="max-w-2xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease }}
        >
          <span className="text-[#E84500] text-xs font-semibold tracking-[0.3em] uppercase">
            Nur für kurze Zeit · Endet am 7. September 2026
          </span>
          <h2
            className="text-4xl sm:text-5xl font-black text-[#F5F5F7] mt-4 mb-14 tracking-tight"
            style={{ fontFamily: "'Playfair Display', serif", letterSpacing: "-0.02em" }}
          >
            Jetzt 299€, bald 499€.
          </h2>
        </motion.div>

        {/* Countdown */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8, ease, delay: 0.1 }}
          className="mb-14"
          data-testid="price-countdown-wrapper"
        >
          <p className="text-[#E84500] text-[11px] font-bold uppercase tracking-[0.25em] mb-5">
            Sonderangebot endet in
          </p>
          <CountdownTimer />
        </motion.div>

        {/* Price block */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.8, ease, delay: 0.15 }}
          className="bg-[#111111] rounded-2xl p-10 mb-8"
          style={{ border: "1px solid rgba(201,168,76,0.15)" }}
          data-testid="launch-price-card"
        >
          <div className="flex items-end justify-center gap-4 mb-6">
            <span className="text-[#86868b] line-through text-2xl">499€</span>
            <span
              className="text-[#C9A84C] text-6xl font-black leading-none"
              style={{ textShadow: "0 0 30px rgba(201,168,76,0.3)" }}
            >
              299€
            </span>
          </div>
          <p className="text-[#86868b] text-sm mb-8">Einmalig · Kein Abo · Sofortiger Zugang</p>
          {[
            "Alle 9 Module · inkl. Bonus-Modul",
            "Lebenslanger Zugang · auch zu Updates",
            "Sofortiger Zugang nach Kauf",
          ].map((f, i) => (
            <div key={i} className="flex items-center gap-3 justify-center mb-3 last:mb-0">
              <CheckCircle className="w-4 h-4 text-[#C9A84C] shrink-0" />
              <span className="text-[#86868b] text-sm">{f}</span>
            </div>
          ))}
          <p className="text-[#86868b]/60 text-xs mt-7" data-testid="tools-cost-note">
            Transparenz: Für die Umsetzung nach dem Kurs fallen ca. 20€/Monat für KI-Tools an.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease, delay: 0.2 }}
        >
          <p className="text-[#C9A84C] text-sm font-semibold mb-6" data-testid="value-anchor">
            Schon eine einzige verkaufte Website bringt dir das 3- bis 10-fache zurück.
          </p>
          <CheckoutButton testId="price-cta-button" />
        </motion.div>
      </div>
    </section>
  );
}
